/**
 * 精彩课堂api
 */

import { getFetch, postFetch } from '@/plugins/http'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
    // 精彩课堂列表
    getWonderfulClassList(data) {
        return getFetch(`${baseHost}/api/liveManage/getWonderfulClassList`, data)
    },
}